<script lang="ts">
	import * as m from '$lib/paraglide/messages';
	import { page } from '$app/stores';
	import { wikiCategoryLabel } from '../../logic/category-labels';
	import type { WikiSidebarSection } from '../../logic/wiki-index';

	let { sections }: { sections: WikiSidebarSection[] } = $props();
</script>

<nav class="wiki-sidebar" aria-label={m.wiki_sidebar_label()}>
	{#each sections as section (section.category)}
		<div class="side-group">
			<h2>{wikiCategoryLabel(section.category)}</h2>
			<ul>
				{#each section.items as item (item.pageId)}
					<li>
						<a
							href={item.href}
							aria-current={$page.url.pathname === item.href ? 'page' : undefined}
						>
							<span>{item.title}</span>
							{#if item.fallback}<span class="lang-chip">EN</span>{/if}
						</a>
					</li>
				{/each}
			</ul>
		</div>
	{/each}
</nav>

<style>
	.wiki-sidebar {
		display: flex;
		flex-direction: column;
		gap: 1.5rem;
	}
	.side-group h2 {
		font-size: 0.72rem;
		font-weight: 700;
		letter-spacing: 0.08em;
		text-transform: uppercase;
		color: var(--v3-muted);
		margin: 0 0 0.5rem;
	}
	.side-group ul {
		list-style: none;
		margin: 0;
		padding: 0;
		display: flex;
		flex-direction: column;
		gap: 0.125rem;
	}
	.side-group a {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 0.5rem;
		font-size: 0.9rem;
		color: var(--v3-muted);
		text-decoration: none;
		padding: 0.35rem 0.6rem;
		border-radius: 0.5rem;
	}
	.side-group a:hover {
		color: var(--v3-text);
		background: var(--v3-surface);
	}
	.side-group a[aria-current='page'] {
		color: var(--v3-text);
		background: var(--v3-surface);
		font-weight: 600;
	}
	.lang-chip {
		font-size: 0.62rem;
		font-weight: 700;
		letter-spacing: 0.06em;
		color: var(--v3-muted);
		border: 1px solid var(--v3-border);
		border-radius: 9999px;
		padding: 0.05rem 0.4rem;
		flex-shrink: 0;
	}
</style>
